import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { Navbar } from '../Navbar';

const useStyle = makeStyles(theme => ({
  root: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  containerStyle: {
    width: '100%',
    backgroundColor: theme.palette.lightGrey,
    textAlign: 'center',
    border: '1px solid black',
    position: 'absolute',
    top: 100,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

export const DropdownMenu = () => {
  const classes = useStyle();
  return (
    <Box className={classes.containerStyle}>
      <Box className={classes.root}>
        <Navbar />
      </Box>

      {/* <ResponsiveHeaderButton />
      <ResponsiveReservedButton>Riservato</ResponsiveReservedButton>
      <ResponsiveLangButton /> */}
    </Box>
  );
};
